// Wrap rich text tables
const tables = document.querySelectorAll('.rich-text table:not([class~="not-rich-text"]):not([class~="not-rich-text"] *)')
for (const table of tables) {
    const wrapper = document.createElement('div')
    wrapper.classList.add('scrolling-table')
    table.replaceWith(wrapper)
    wrapper.appendChild(table)
}